<template>
  <div>
    <div v-if="$vuetify.breakpoint.xsOnly">
      <button
        class="filterChipWrapper"
        @click="showMenu = true"
      >
        <v-chip
          outlined
          color="#6D7079"
          id="filterChipMobile"
          :aria-expanded="showMenu ? 'true':'false'"
          :class="showMenu || selected.length > 0 ? 'filterChipActive filterChip' : 'filterChip'"
        >
          {{ name }}
          <v-icon class="ml-2" v-if="selected.length === 0">
            arrow_drop_down
          </v-icon>
          <v-icon small color="#C8DCF0" class="ml-2 closeIconChip" v-else @click.stop="clearFilter">
            close
          </v-icon>
        </v-chip>
      </button>
      <v-dialog v-model="showMenu" v-if="$vuetify.breakpoint.xsOnly">
        <v-card
          class="filterMenu filterMenuXs"
          @click.native.stop.prevent
        >
          <v-card-title class=" filterMenuTitle py-3">
            {{ name }}
          </v-card-title>
          <v-btn
            icon
            small
            class="filterMenuCloseButton"
            @click.stop="showMenu = false"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
          <ul class="pl-3">
            <li
              v-for="item in items"
              :key="item.id"
              style="list-style: none;"
            >
              <v-checkbox
                v-model="selected"
                :label="item.name"
                :value="item.id"
                dense
                class="mt-0 pt-0"
                @change="selectedItems"
                id="focusCheckbox"
              />
            </li>
          </ul>
        </v-card>
      </v-dialog>
    </div>
    <v-menu
      v-if="$vuetify.breakpoint.smAndUp"
      v-model="showMenu"
      offset-y
      bottom
      :nudge-bottom="12"
      :nudge-left="left ? 200 : 0"
      transition="scale-transition"
      origin="top left"
      :close-on-content-click="false"
      @click.native.stop.prevent
      :attach="'.chip' + className"
      :min-width="$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.width : 280"
      :max-height="480"
      :rounded="$vuetify.breakpoint.xsOnly ? '0' : '4px'"
    >
      <template v-slot:activator="{ on, attrs }">
        <button
          v-bind="attrs"
          v-on="on"
          :class="'filterChipWrapper chip' + className"
          @click="showMenu = true"
        >
          <v-chip
            outlined
            color="#6D7079"
            id="filterChip"
            :aria-expanded="showMenu ? 'true':'false'"
            :class="showMenu || selected.length > 0 ? 'filterChipActive filterChip' : 'filterChip'"
          >
            {{ name }}
            <v-icon class="ml-2" v-if="selected.length === 0">
              arrow_drop_down
            </v-icon>
            <v-icon small color="#C8DCF0" class="ml-2 closeIconChip" v-else @click.stop="clearFilter">
              close
            </v-icon>
          </v-chip>
        </button>
      </template>
      <v-card
        :class="{'filterMenu': $vuetify.breakpoint.smAndUp, 'filterMenu filterMenuMobile': $vuetify.breakpoint.xsOnly}"
        @click.native.stop.prevent
      >
        <v-card-title class=" filterMenuTitle py-3">
          {{ name }}
        </v-card-title>
        <v-btn
          icon
          small
          class="filterMenuCloseButton"
          @click.stop="showMenu = false"
        >
          <v-icon>
            close
          </v-icon>
        </v-btn>
        <ul class="pl-3">
          <li
            v-for="item in items"
            :key="item.id"
            style="list-style: none;"
          >
            <v-checkbox
              v-model="selected"
              :label="item.name"
              :value="item.id"
              dense
              class="mt-0 pt-0"
              @change="selectedItems"
              id="focusCheckbox"
            />
          </li>
        </ul>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'ChipFilter',
  props: {
    id: String,
    items: Array,
    name: String,
    value: Array,
    left: Boolean,
    right: Boolean
  },
  data: function () {
    return {
      showMenu: false,
      selected: this.value,
      clickedClearButton: false,
    }
  },
  model: {},
  methods: {
    selectedItems() {
      this.$emit('input', this.selected);
    },
    clearFilter() {
      this.selected = [];
      this.$emit('input', this.selected);
    }
  },
  computed: {
    className() {
      return this.id.split(" ").join('');
    },
  },
  watch: {
    clearFilters: function (newValue) {
      if (newValue) this.selected = [];
    },
    value(newValue) {
      this.selected = newValue;
    }
  },
}
</script>
<style lang="scss" scoped>

::v-deep.v-dialog__content {
  align-items: start !important;
}

::v-deep.v-dialog__content > .v-dialog {
  margin: 0 !important;
  border-radius: 0 !important;
  top: 0 !important;
  max-height: 480px;
}
@media screen and (max-height: 480px) {
  ::v-deep.v-dialog__content > .v-dialog {
    max-height: 100vh;
  }
}

.filterMenu {
  position: relative;
  width: 280px;

  .filterMenuTitle {
    font-size: 16px;
    color: #041E42;
    font-weight: bold;
  }

  .filterMenuCloseButton {
    position: absolute;
    top: 12px;
    right: 12px;

    &:focus {
      border: 2px solid #041E42 !important;
      outline: 1px solid transparent !important;
    }
  }
}

.filterMenuXs {
  width: 100%;
  max-height: 100%;
  border-radius: 0;
}

.filterChipWrapper {
  border-radius: 50%;
  margin-right: 12px;

  &:focus {
    outline: none;
  }

  &:focus .filterChip {
    border: 2px solid #041E42 !important;
  }

  .filterChipActive {
    border: 2px solid #041E42 !important;
  }
}

::v-deep.v-input--checkbox label.v-label {
  color: #000000 !important;
}

::v-deep input#focusCheckbox:focus + .v-input--selection-controls__ripple::before {
  border: 2px solid #041E42;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 1;
}

#filterChip {
  background-color: #FFFFFF !important;
}

#filterChipMobile {
  background-color: #FFFFFF !important;
}

#filterChipMobile.filterChipActive {
  background-color: #C8DCF0 !important;
  color: #000000 !important;
}

#filterChip.filterChipActive {
  background-color: #C8DCF0 !important;
  color: #000000 !important;
}

.closeIconChip {
  border-radius: 50%;
  background-color: #041E42;
}
</style>
